import createSagaMiddleware from "@redux-saga/core"
import { configureStore } from "@reduxjs/toolkit"
import rootReducers from "./reducers"
import rootSaga from "./rootSaga"
import storageSession from "redux-persist/lib/storage/session"
import persistReducer from "redux-persist/es/persistReducer"

const persistConfig = {
    key: "root",
    storage: storageSession,
}

const sagaMiddleware = createSagaMiddleware()

const persistedReducer = persistReducer(persistConfig, rootReducers)

const store = configureStore({
    reducer: persistedReducer,
    middleware: [sagaMiddleware],
})

sagaMiddleware.run(rootSaga)

export { store }
